var map = {
	"./cnn-money-x2.png": 2056,
	"./economist-x2.png": 2057,
	"./mashable-x2.png": 2058,
	"./tech-crunch-x2.png": 2059,
	"./thenewyorker-x2.png": 2060,
	"./thrillist-x2.png": 2061,
	"./time-x2.png": 2062,
	"./usa-today-x2.png": 2063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2258;